import { call, put } from 'redux-saga/effects';

import { apiGeneral, notify } from 'services';
import { ICreateRequest } from 'interfaces/create-duck';
import { requestErrorHandler } from 'utils';
import { CreateDocumentActions } from 'store/ducks/documents';

export function* createDocumentRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/document`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateDocumentActions.success(data));
    notify('success', 'Documento enviado com sucesso');
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(CreateDocumentActions.failure(errorMessage));
  }
}
